export default (siteName) => [
    {
        path: 'salary',
        name: 'salary',
        component: () => import('../../components/dashboard/Finance/Salary/index'),
        meta: {
            title: `薪資管理${siteName}`,
            activeMenu: 'finance',
        },
    },
    {
        path: 'salary/:year/:month/edit/',
        name: 'salary-edit',
        component: () => import('../../components/dashboard/Finance/Salary/EditPage_New'),
        meta: {
            title: `人事薪資-編輯${siteName}`,
            activeMenu: 'finance',
        },
    },
    {
        path: 'salary/add',
        name: 'salary-add',
        component: () => import('../../components/dashboard/Finance/Salary/EditPage_New'),
        meta: {
            title: `人事薪資-新增${siteName}`,
            activeMenu: 'finance',
        },
    },
];
